import { HomeWorkoutSequence, ISessionSequenceInfo } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { IAppStore } from '../reducer';
import { IShouldShowOnWorkout, shouldShowElementsSelector } from '../selectors';

interface IStoreProps {
  shouldShowElements: IShouldShowOnWorkout;
  sessionSequenceInfo: ISessionSequenceInfo | null;
  workoutSession: HomeWorkoutSequence | null;
}

const HomeWorkoutDebugInfo: FunctionComponent<IStoreProps> = (
  {
    shouldShowElements,
    sessionSequenceInfo,
    workoutSession,
  },
) => {
  const shouldShowKeys = Object.keys(shouldShowElements);
  const elementsToDisplay = shouldShowKeys
    .filter((key) => shouldShowElements[key])
    .map((visibleElement) => <Text style={styles.itemText}>{visibleElement}</Text>);

  const currentSequence = sessionSequenceInfo?.currentSequence;
  const sequences = workoutSession?.sequences?.length;
  const cachedSequences = (workoutSession?.sequences ?? [])
    .slice(sessionSequenceInfo?.currentIndex ?? 0)
    .reduce((acc, session) => acc + ((session as any).cached ? 1 : 0), 0);

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>Display elements</Text>
      {elementsToDisplay}

      {currentSequence
        && (
        <>
          <Text style={styles.heading}>Session Sequence Info</Text>
          <Text style={styles.itemText}>
            Name:
            {currentSequence.displayName}
          </Text>
          <Text style={styles.itemText}>
            Video:
            {currentSequence.videoFile}
          </Text>
          <Text style={styles.itemText}>
            Sequences:
            {sequences || '?'}
          </Text>
          <Text style={styles.itemText}>
            Index:
            {sessionSequenceInfo?.currentIndex}
          </Text>
          <Text style={styles.itemText}>
            Cached:
            {cachedSequences}
            {' '}
            upcoming
          </Text>
        </>
        )}

    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: Theme.WHITE,
    padding: defaultScale(10),
    backgroundColor: 'rgba(102, 102, 102, 0.5)',
    zIndex: 10,
  },
  heading: {
    ...Theme.textStyle.smallBold,
    color: Theme.WHITE,
  },
  itemText: {
    ...Theme.textStyle.small,
    color: Theme.WHITE,
  },
});

const mapStateToProps = (state: IAppStore): IStoreProps => ({
  shouldShowElements: shouldShowElementsSelector(state),
  sessionSequenceInfo: state.homeWorkouts.currentSessionSequenceInfo,
  workoutSession: state.homeWorkouts.homeWorkoutSession,
});

export default connect(mapStateToProps)(HomeWorkoutDebugInfo);
